import {
  GET_MUTUAL_FUND_HOLDING,
  PURCHASE_DETAILS_FAIL,
  PURCHASE_DETAILS_SUCCESS,
  NOTIFICATIONS_SUCCESS,
  NOTIFICATIONS_FAIL,
  GIFT_INVESTMENT_SUCCESS,
  GIFT_INVESTMENT_FAIL,
  GIFT_SENT_FAIL,
  GIFT_SENT_SUCCESS,
  GET_MUTUAL_FUNDs_REDEEM,
  GET_MUTUAL_FUND_INVESTMENT,
  GET_FUND_SIP_LIST,
  GET_MUTUAL_FUND__FUND_CARD,
  GET_MUTUAL_FUND__FUND_HOLDING,
  GET_MUTUAL_FUND_GRAPHDATA,
  GET_MUTUAL_FUND__SIP_DETAIL,
  ORDER_MUTUAL_FUND,
  GET_MUTUAL_FUNDs_OTPGENERATE,
  GET_MUTUAL_FUNDs_OTPVERIFY,
  CREATE_MF_MANDATE,
  GET_MUTUAL_FUND_SIP,
  CANCEL_MF_SIP,
  GET_NFO_LIST,
  SKIP_MF_SIP,
  LUMPSUM_ORDER_MUTUAL_FUND
} from "./types";
import {
  MF_FUND_DEATILS,
  MF_SCHEMS_URL,
  MF_FUNDLIST,
  API_BASE_URL,
  MF_HOLDINGS,
  MF_REDEEM,
  MF_PORTFOLIO_DATA,
  MF_GRAPH_NAV,
  MF_ALL_HOLDINGS,
  MF_ORDER,
  CREATE_LUMPSUM_MUTUAL_ORDER_FUND_URL,
  MF_OTP_GENERATE,
  MF_OTP_VERIFY,
  MF_SIP_MANDATE,
  PAYMENT_BASE_URL,
  MF_SIP_STATUS,
  MF_SIP_API,
  CANCEL_MF_SIP_URL,
  GET_NFO_LIST_URL,
  SKIP_MF_SIP_URL,
} from "../../Api/EndPoints";
import { APIClient } from "../../Api/APIClient";
import * as Models from "../../models";
/**************************************PortFolio Action ****************************************************/

export function getMFHoldings(
  req: Models.MutualFundKYCRequestStatus,
  token: string
) {
  return (dispatch: (arg0: { type: string }) => void, getState: any) =>
    new Promise((resolve, reject) => {
      dispatch({ type: GET_MUTUAL_FUND_HOLDING });
      const apiClient = APIClient.getInstance();
      if (apiClient) {
        apiClient
          .postData(API_BASE_URL + MF_HOLDINGS, JSON.stringify(req), token)
          .then((response: any) => {
            let result = response;
            getInvestmentSuccess(dispatch, result);
            resolve(result);
          })
          .catch((error: any) => {
            let errorMessage = error.message;
            getInvestmentFailed(dispatch, errorMessage);
            reject(errorMessage);
          });
      }
    });
}

// Genrate OTP
export function otpGenerateForMutualFund(req: any, token: string) {
  return (dispatch: (arg0: { type: string }) => void, getState: any) =>
    new Promise((resolve, reject) => {
      dispatch({ type: GET_MUTUAL_FUNDs_OTPGENERATE });
      const apiClient = APIClient.getInstance();
      if (apiClient) {
        apiClient
          .postData(API_BASE_URL + MF_OTP_GENERATE, JSON.stringify(req), token)
          .then((response: any) => {
            let result = response;
            resolve(result);
          })
          .catch((error: any) => {
            let errorMessage = error.message;
            reject(errorMessage);
          });
      }
    });
}

//verifyOTP
export function otpVerifyForMutualFund(req: any, token: string) {
  return (dispatch: (arg0: { type: string }) => void, getState: any) =>
    new Promise((resolve, reject) => {
      dispatch({ type: GET_MUTUAL_FUNDs_OTPVERIFY });
      const apiClient = APIClient.getInstance();
      if (apiClient) {
        apiClient
          .postData(API_BASE_URL + MF_OTP_VERIFY, JSON.stringify(req), token)
          .then((response: any) => {
            let result = response;
            resolve(result);
          })
          .catch((error: any) => {
            let errorMessage = error.message;
            reject(errorMessage);
          });
      }
    });
}

// Redeem MF
export function redeemMutualFund(req: any, token: string) {
  return (dispatch: (arg0: { type: string }) => void, getState: any) =>
    new Promise((resolve, reject) => {
      dispatch({ type: GET_MUTUAL_FUNDs_REDEEM });
      const apiClient = APIClient.getInstance();
      if (apiClient) {
        apiClient
          .postData(API_BASE_URL + MF_REDEEM, JSON.stringify(req), token)
          .then((response: any) => {
            let result = response;
            getInvestmentSuccess(dispatch, result);
            resolve(result);
          })
          .catch((error: any) => {
            let errorMessage = error.message;
            getInvestmentFailed(dispatch, errorMessage);
            reject(errorMessage);
          });
      }
    });
}

//MF Portfolio
export function getMFPortfolioData(
  req: Models.MutualFundPortfolioRequest,
  token: string
) {
  return (dispatch: (arg0: { type: string }) => void, getState: any) =>
    new Promise((resolve, reject) => {
      dispatch({ type: GET_MUTUAL_FUND_INVESTMENT });
      const apiClient = APIClient.getInstance();
      if (apiClient) {
        apiClient
          .postData(
            API_BASE_URL + MF_PORTFOLIO_DATA,
            JSON.stringify(req),
            token
          )
          .then((response: any) => {
            let result = response;
            getInvestmentSuccess(dispatch, result);
            resolve(result);
          })
          .catch((error: any) => {
            let errorMessage = error.message;
            getInvestmentFailed(dispatch, errorMessage);
            reject(errorMessage);
          });
      }
    });
}

export function getFundSipList(req: Models.FundSipRequest, token: string) {
  return (dispatch: (arg0: { type: string }) => void, getState: any) =>
    new Promise((resolve, reject) => {
      dispatch({ type: GET_FUND_SIP_LIST });
      dispatch({ type: GET_MUTUAL_FUND_INVESTMENT });
      const apiClient = APIClient.getInstance();
      if (apiClient) {
        apiClient
          .postData(API_BASE_URL + MF_FUNDLIST, JSON.stringify(req), token)
          .then((response: any) => {
            let result = response;
            getInvestmentSuccess(dispatch, result);
            resolve(result);
          })
          .catch((error: any) => {
            let errorMessage = error.message;
            getInvestmentFailed(dispatch, errorMessage);
            reject(errorMessage);
          });
      }
    });
}

export function getFundCard(req: Models.MutualFundsCardRequest, token: string) {
  return (dispatch: (arg0: { type: string }) => void, getState: any) =>
    new Promise((resolve, reject) => {
      dispatch({ type: GET_MUTUAL_FUND__FUND_CARD });
      const apiClient = APIClient.getInstance();
      if (apiClient) {
        apiClient
          .postData(API_BASE_URL + MF_SCHEMS_URL, JSON.stringify(req), token)
          .then((response: any) => {
            let result = response;
            getInvestmentSuccess(dispatch, result);
            resolve(result);
          })
          .catch((error: any) => {
            let errorMessage = error.message;
            getInvestmentFailed(dispatch, errorMessage);
            reject(errorMessage);
          });
      }
    });
}

export function getFundisin(
  req: Models.MutualFundsDetailRequest,
  token: string
) {
  return (dispatch: (arg0: { type: string }) => void, getState: any) =>
    new Promise((resolve, reject) => {
      dispatch({ type: GET_MUTUAL_FUND__SIP_DETAIL });
      const apiClient = APIClient.getInstance();
      if (apiClient) {
        apiClient
          .postData(API_BASE_URL + MF_FUND_DEATILS, JSON.stringify(req), token)
          .then((response: any) => {
            let result = response;
            getInvestmentSuccess(dispatch, result);
            resolve(result);
          })
          .catch((error: any) => {
            let errorMessage = error.message;
            getInvestmentFailed(dispatch, errorMessage);
            reject(errorMessage);
          });
      }
    });
}

export function getFundHolding(
  req: Models.MutualFundsHoldingRequest,
  token: string
) {
  return (dispatch: (arg0: { type: string }) => void, getState: any) =>
    new Promise((resolve, reject) => {
      dispatch({ type: GET_MUTUAL_FUND__FUND_HOLDING });
      const apiClient = APIClient.getInstance();
      if (apiClient) {
        apiClient
          .postData(API_BASE_URL + MF_ALL_HOLDINGS, JSON.stringify(req), token)
          .then((response: any) => {
            let result = response;
            getInvestmentSuccess(dispatch, result);
            resolve(result);
          })
          .catch((error: any) => {
            let errorMessage = error.message;
            getInvestmentFailed(dispatch, errorMessage);
            reject(errorMessage);
          });
      }
    });
}

//GRaph Data
export function getGraphNAVData(data: any, token: any) {
  return (dispatch: (arg0: { type: string }) => void, getState: any) =>
    new Promise((resolve, reject) => {
      dispatch({ type: GET_MUTUAL_FUND_GRAPHDATA });
      const apiClient = APIClient.getInstance();
      if (apiClient) {
        apiClient
          .postData(API_BASE_URL + MF_GRAPH_NAV, JSON.stringify(data), token)
          .then((response: any) => {
            let result = response;
            resolve(result);
          })
          .catch((error: any) => {
            let errorMessage = error.message;
            reject(errorMessage);
          });
      }
    });
}

//Mandate SIP
export function createSIPMandate(req: any, token: string) {
  return (dispatch: (arg0: { type: string }) => void, getState: any) =>
    new Promise((resolve, reject) => {
      dispatch({ type: CREATE_MF_MANDATE });
      const apiClient = APIClient.getInstance();
      if (apiClient) {
        apiClient
          .postData(PAYMENT_BASE_URL + MF_SIP_MANDATE, JSON.stringify(req), token)
          .then((response: any) => {
            let result = response;
            getInvestmentSuccess(dispatch, result);
            resolve(result);
          })
          .catch((error: any) => {
            let errorMessage = error.message;
            getInvestmentFailed(dispatch, errorMessage);
            reject(errorMessage);
          });
      }
    });
}

export function checkSIPMandate(req: Models.checkSipStatus, token: string) {
  let checkStatus = PAYMENT_BASE_URL + MF_SIP_STATUS + req.id;
  return (dispatch: (arg0: { type: string }) => void, getState: any) =>
    new Promise((resolve, reject) => {
      dispatch({ type: CREATE_MF_MANDATE });
      const apiClient = APIClient.getInstance();
      if (apiClient) {
        apiClient
          .postData(checkStatus, "", token)
          .then((response: any) => {
            let result = response;
            getInvestmentSuccess(dispatch, result);
            resolve(result);
          })
          .catch((error: any) => {
            let errorMessage = error.message;
            getInvestmentFailed(dispatch, errorMessage);
            reject(errorMessage);
          });
      }
    });
}

export function getSIPList(mfid: string, token: any) {
  return (dispatch: (arg0: { type: string }) => void, getState: any) =>
    new Promise((resolve, reject) => {
      dispatch({ type: GET_MUTUAL_FUND_SIP });
      const apiClient = APIClient.getInstance();
      if (apiClient) {
        apiClient
          .getRequest(PAYMENT_BASE_URL + MF_SIP_API + mfid, token)
          .then((response: any) => {
            let result = response;
            getNotificationSuccess(dispatch, result);
            resolve(result);
          })
          .catch((error: any) => {
            let errorMessage = error.message;
            if (error?.status === 401) {
              getNotificationSuccess(dispatch, error);
              resolve(error);
              return;
            }
            getNotificationFailed(dispatch, errorMessage);
            reject(errorMessage);
          });
      }
    });
}

export function cancelMFSIP(sipId: string, token: any) {
  return (dispatch: (arg0: { type: string }) => void, getState: any) =>
    new Promise((resolve, reject) => {
      dispatch({ type: CANCEL_MF_SIP });
      const apiClient = APIClient.getInstance();
      if (apiClient) {
        apiClient
          .postData(PAYMENT_BASE_URL + CANCEL_MF_SIP_URL + sipId, {}, token)
          .then((response: any) => {
            let result = response;
            getNotificationSuccess(dispatch, result);
            resolve(result);
          })
          .catch((error: any) => {
            let errorMessage = error.message;
            if (error?.status === 401) {
              getNotificationSuccess(dispatch, error);
              resolve(error);
              return;
            }
            getNotificationFailed(dispatch, errorMessage);
            reject(errorMessage);
          });
      }
    });
}
export function skipMFSIP(req: Models.SkipRequest, token: string) {
  return (dispatch: (arg0: { type: string }) => void, getState: any) =>
    new Promise((resolve, reject) => {
      dispatch({ type: SKIP_MF_SIP });
      const apiClient = APIClient.getInstance();
      if (apiClient) {
        apiClient
          .postData(PAYMENT_BASE_URL + SKIP_MF_SIP_URL, JSON.stringify(req), token)
          .then((response: any) => {
            let result = response;
            getInvestmentSuccess(dispatch, result);
            resolve(result);
          })
          .catch((error: any) => {
            let errorMessage = error.message;
            getInvestmentFailed(dispatch, errorMessage);
            reject(errorMessage);
          });
      }
    });
}

export function orderLumpsumMutualFund(
  req: Models.MutualLumpSumFundCreateOrderRequest,
  token: string
) {
  return (dispatch: (arg0: { type: string }) => void, getState: any) =>
    new Promise((resolve, reject) => {
      dispatch({ type: LUMPSUM_ORDER_MUTUAL_FUND });
      const apiClient = APIClient.getInstance();
      if (apiClient) {
        apiClient
          .postData(PAYMENT_BASE_URL + CREATE_LUMPSUM_MUTUAL_ORDER_FUND_URL, JSON.stringify(req), token)
          .then((response: any) => {
            let result = response;
            getInvestmentSuccess(dispatch, result);
            resolve(result);
          })
          .catch((error: any) => {
            let errorMessage = error.message;
            getInvestmentFailed(dispatch, errorMessage);
            reject(errorMessage);
          });
      }
    });
}
export function orderMutualFund(
  req: Models.MutualFundCreateOrderRequest,
  token: string
) {
  return (dispatch: (arg0: { type: string }) => void, getState: any) =>
    new Promise((resolve, reject) => {
      dispatch({ type: ORDER_MUTUAL_FUND });
      const apiClient = APIClient.getInstance();
      if (apiClient) {
        apiClient
          .postData(API_BASE_URL + MF_ORDER, JSON.stringify(req), token)
          .then((response: any) => {
            let result = response;
            getInvestmentSuccess(dispatch, result);
            resolve(result);
          })
          .catch((error: any) => {
            let errorMessage = error.message;
            getInvestmentFailed(dispatch, errorMessage);
            reject(errorMessage);
          });
      }
    });
}

export function getNFOFundList(token: string) {
  return (dispatch: (arg0: { type: string }) => void, getState: any) =>
    new Promise((resolve, reject) => {
      dispatch({ type: GET_NFO_LIST });
      const apiClient = APIClient.getInstance();
      if (apiClient) {
        apiClient
          .getRequest(PAYMENT_BASE_URL + GET_NFO_LIST_URL, token)
          .then((response: any) => {
            let result = response;
            getInvestmentSuccess(dispatch, result);
            resolve(result);
          })
          .catch((error: any) => {
            let errorMessage = error.message;
            getInvestmentFailed(dispatch, errorMessage);
            reject(errorMessage);
          });
      }
    });
}

const getInvestmentFailed = (
  dispatch: (arg0: { type: string; payload: any }) => void,
  errorMessage: any
) => {
  dispatch({
    type: GIFT_INVESTMENT_FAIL,
    payload: errorMessage,
  });
};
const getInvestmentSuccess = (
  dispatch: (arg0: { type: string; payload: any }) => void,
  errorMessage: any
) => {
  dispatch({
    type: GIFT_INVESTMENT_SUCCESS,
    payload: errorMessage,
  });
};

const getNotificationFailed = (
  dispatch: (arg0: { type: string; payload: any }) => void,
  errorMessage: any
) => {
  dispatch({
    type: NOTIFICATIONS_FAIL,
    payload: errorMessage,
  });
};
const getNotificationSuccess = (
  dispatch: (arg0: { type: string; payload: any }) => void,
  errorMessage: any
) => {
  dispatch({
    type: NOTIFICATIONS_SUCCESS,
    payload: errorMessage,
  });
};
